import React, { useState, useRef } from 'react';
import _ from 'lodash';
import { useSources } from 'hooks';
import { CSVLink } from 'react-csv';
import { IconButton } from '@material-ui/core';
import { MdDownload } from 'react-icons/md';

import { formatDate } from 'utils/time';
import { Table, Tooltip } from 'components';
import API from 'utils/api';

const InfluencerUsersTable = props => {
  const [dataReport, setDataReport] = useState([]);
  const [csvLink, setCsvLink] = useState();
  const tableRef = useRef();

  const sources = useSources();

  const { dateFrom, dateTo, showDeletedUsers } = props;

  const columns = [
    {
      title: 'User',
      field: 'name',
      render: rowData => {
        let name = 'Anonymous user';

        if (rowData.name) {
          name = rowData.name;
        } else if (rowData.phone) {
          name = rowData.phone;
        }

        return <div>{name}</div>;
      },
    },
    {
      title: 'Referral from',
      field: 'referralFrom',
      render: rowData => {
        let code = _.get(rowData, 'referralFrom', null);

        if (rowData.type === 'waitlist') {
          code = _.get(rowData, 'waitlist.referralCode', null);
        }

        return <div>{code}</div>;
      },
    },
    {
      title: 'Engagement',
      field: 'engagement',
    },
    {
      title: 'Subscribed',
      field: 'createdAt',
      render: rowData => <div>{formatDate(rowData.createdAt)}</div>,
      type: 'date',
    },
  ];

  const exportCSV = () => {
    let query = {};

    const search = _.get(tableRef, 'current.state.search', '');

    if (search.length > 0) {
      query.name = search;
    }

    API.getUserInteractions(
      {
        ...query,
        hideDeletedUsers: !showDeletedUsers,
      },
      sources
    ).then(({ data }) => {
      if (data && data.docs) {
        const users = data.docs.map(user => {
          let name = 'Anonymous user';
          if (user.name) {
            name = user.name;
          } else if (user.phone) {
            name = user.phone;
          }
          return {
            user: name,
            referral: user.referralFrom,
            engagement: user.engagement,
            subscribed: user.createdAt,
          };
        });
        setDataReport(users);
        csvLink.link.click();
      }
    });
  };

  const fetchData = ({ pageSize, page, search, sort }) => {
    let query = {};

    if (search && search.length > 0) {
      query.name = search;
    }

    return API.getUserInteractions(
      {
        ...query,
        per_page: pageSize,
        page,
        from: dateFrom,
        to: dateTo,
        sort: sort ? sort : 'createdAt',
        hideDeletedUsers: !showDeletedUsers,
      },
      sources
    );
  };

  const renderControlPanel = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <IconButton onClick={exportCSV}>
          <Tooltip title="Click to export table data" placement="top">
            <MdDownload />
          </Tooltip>
        </IconButton>
      </div>
    );
  };

  return (
    <>
      <CSVLink
        data={dataReport}
        filename="data.csv"
        className="hidden"
        ref={r => setCsvLink(r)}
        target="_blank"
      />

      <Table
        title="Users"
        columns={columns}
        data={fetchData}
        tableRef={tableRef}
        controlPanel={renderControlPanel()}
      />
    </>
  );
};

export default InfluencerUsersTable;
